import * as React from 'react';

// stylguidist requires a react component to be exported to generate a place in the styleguide
export const ScreenReaderOnly: React.FC = () => <>dummy</>;
